import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  isEmailVerified: boolean;
  role: "admin" | "customer";
  image?: string;
  gender: "male" | "female" | "other";
  contactNo: string;
  bio: string;
  status: "active" | "pending" | "blocked";
  walletPoint: number;
  commissionBalance: number;
  createdAt: string;
  updatedAt: string;
}

export interface UserResponse {
  success: boolean;
  message?: string;
  data: User[] | { result: User[]; meta: any };
  meta?: {
    page: number;
    limit: number;
    total: number;
    totalPage: number;
  };
}

export const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    // prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("accessToken");
    //   if (token) {
    //     headers.set("Authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
    credentials: "include",
  }),
  tagTypes: ["Users"],
  endpoints: (builder) => ({
    getUsers: builder.query<
      UserResponse,
      { page?: number; limit?: number; searchTerm?: string; role?: string }
    >({
      query: (params) => ({
        url: "/user",
        params: {
          page: params.page,
          limit: params.limit,
          searchTerm: params.searchTerm || undefined,
          role: params.role || undefined,
        },
      }),
      providesTags: ["Users"],
    }),
    getUserById: builder.query<{ success: boolean; data: User }, string>({
      query: (id) => `/user/${id}`,
      providesTags: (result, error, id) => [{ type: "Users", id }],
    }),
    createUser: builder.mutation<
      { success: boolean; data: User },
      Partial<User>
    >({
      query: (body) => ({
        url: "/user",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Users"],
    }),
    updateUser: builder.mutation<
      { success: boolean; data: User },
      { id: string; data: Partial<User> }
    >({
      query: ({ id, data }) => ({
        url: `/user/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    deleteUser: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Users"],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserByIdQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApi;
